var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text1"},[_vm._v("Oops... Page Under Development..!")]),_c('div',{staticClass:"center-screen"},[_c('v-img',{staticClass:"img-size",attrs:{"src":_vm.imageSrc,"alt":"Under Development","contain":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }